import { getBoundingClientRect, getViewportDimensions, selectRange, toRanges, ViewportDimensions } from '@mbrtargeting/metatag-utils';

/**
 * Calculates the space between the left side of an element and the viewport width.
 *
 * @param element HTMLElement to measure
 * @returns a width range to be used as target, e.g. '300-400'
 */
export const calculateLeftSpaceToViewportBorder = (element: HTMLElement): string => {
    const widthSteps = [0, 100, 200, 300, 400, 500, 6001];

    const win: Window = element.ownerDocument?.defaultView ?? window;
    const { viewportWidth }: ViewportDimensions = getViewportDimensions(win);
    const { left = 0 }: DOMRect = getBoundingClientRect(element);
    const space: number = Math.max(0, viewportWidth - left);

    return toRanges(widthSteps).find(selectRange(space))?.join('-') ?? '0';
};
